export default __webpack_public_path__ + "static/media/07.17.25 Minutes Reg Mtg.a5989da8.pdf";